import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { INotificationSplit, IMessage, NotificationType } from '@settings/models';
@Injectable({
  providedIn: 'root'
})
export class DefaultNotificationsDOS {
  private _defaultNotificationsSubject: BehaviorSubject<INotificationSplit[]> = new BehaviorSubject([]);
  readonly defaultNotifications$ = this._defaultNotificationsSubject.asObservable();

  private _defaultNotificationMessagesSubject: BehaviorSubject<IMessage[]> = new BehaviorSubject([]);
  readonly defaultNotificationMessages$ = this._defaultNotificationMessagesSubject.asObservable();

  get defaultNotifications(): INotificationSplit[] {
    return this._defaultNotificationsSubject.value;
  }

  get defaultNotificationMessages(): IMessage[] {
    return this._defaultNotificationMessagesSubject.value;
  }

  updateDefaultNotifications(defaultNotifications: INotificationSplit[]): void {
    this._defaultNotificationsSubject.next(defaultNotifications);
  }

  updateDefaultNotificationMessages(defaultNotificationMessages: IMessage[]): void {
    this._defaultNotificationMessagesSubject.next(defaultNotificationMessages);
  }

  discardDefaultNotificationsChanges(types: NotificationType[]): void {
    this._defaultNotificationsSubject.next([...this._defaultNotificationsSubject.value]);
  }

  discardDefaultNotificationMessageChanges(types: NotificationType[]): void {
    this._defaultNotificationMessagesSubject.next([...this._defaultNotificationMessagesSubject.value]);
  }
}
